module.exports = flarum.core.compat['admin/app'];